import { isURL } from 'validator';

export default function isUrl(protocols: string[], errorMessage: string, value: unknown): string | true {
    return (typeof value === 'string' && isURL(value, { protocols, require_protocol: true })) || errorMessage;
}
